import { ACCOUNTING_SECTION } from "./accountingPlaceholders";

export const REPORTS_SECTION = "Reports";
export const FINANCE_REPORTS_PARENT = "Financial Reports";

/** Breadcrumb props for accounting pages shown under Reports → Finance. */
export function accountingReportBreadcrumbs({ reportMode, title }) {
  if (!reportMode) {
    return { mainTitle: ACCOUNTING_SECTION, parent: ACCOUNTING_SECTION, title };
  }
  return { mainTitle: REPORTS_SECTION, parent: FINANCE_REPORTS_PARENT, title };
}
